import { Component, OnInit, inject, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms'; // Importa FormsModule
import { CommonModule } from '@angular/common';
import { ModalComponent } from "../../modal/modal.component";
import { InicioService } from '../../../services/inicio.service';
import { UsuarioService } from '../../../services/usuario.service';
import { EditarComponent } from "./editar/editar.component";
import { AgregarComponent } from "./agregar/agregar.component";

@Component({
  selector: 'app-listar-institucionales',
  standalone: true,
  imports: [ModalComponent, CommonModule, FormsModule, EditarComponent, AgregarComponent],
  templateUrl: './listar-institucionales.component.html',
  styleUrl: './listar-institucionales.component.css'
})
export class ListarInstitucionalesComponent implements OnInit {
  @ViewChild(ModalComponent) mdl!: ModalComponent;

  titulo!: string;
  tipo_color!: string;
  letra_color!: string;
  mensaje!: string;
  user: any;
  sel_edo!: number;
  sel_rol!: number;
  estado: any = [];
  roles: any = [];
  resultado: any = [];
  filteredResultado: any[] = []; // Nuevo array para los resultados filtrados
  errorMessage: string = '';
  searchTerm: string = ''; // Variable para almacenar el término de búsqueda
  isEditar: boolean = false;
  isAgregar: boolean = false;
  id_institucional_envio: string = '';
  nombre_institucional_envio: string = '';

  private srvLogin = inject(InicioService);
  private servicios = inject(UsuarioService);


  ngOnInit(): void {
    this.srvLogin.user$.subscribe(user => { this.user = user; });
  }

  ngAfterViewInit(): void {
    this.mdl.cargando();
    this.servicios.listarInstitucional('1','11').subscribe({
      next: (rs) => {
        this.mdl.cerrar();
        this.estado = rs.data['estado'];
        this.roles = rs.data['rol'];
        this.sel_edo = 1;
        this.sel_rol = 11
        this.resultado = rs.data['institucional'];
        console.log('prueba:   ',rs.data)
        this.filteredResultado = [...this.resultado]; // Actualiza los resultados filtrados al cambiar el año
      },
      error: (error) => {
        this.errorMessage = error.message; // Muestra el mensaje de error al usuario
        //console.error("Error en el componente:", error); // Registro del error en el componente
      }
    });
  }

  // Método para filtrar la tabla
  buscar() {
    this.filteredResultado = this.resultado.filter((item: any) => {
      const identificacion = item.identificacion ? this.quitarAcentos(item.identificacion.toLowerCase()) : '';
      const nombre = item.nombre_full ? this.quitarAcentos(item.nombre_full.toLowerCase()) : '';
      const estado = item.estado ? this.quitarAcentos(item.estado.toLowerCase()) : '';
      const term = this.searchTerm.toLowerCase();
      return (
        identificacion.includes(term) ||
        nombre.includes(term) ||
        estado.includes(term)
      );
    });
  }

  consulta_combos(){
    let rol = (document.getElementById('rol') as HTMLInputElement);
    let estado = (document.getElementById('estado') as HTMLInputElement);
    this.mdl.cargando();
    this.servicios.listarInstitucional(estado.value,rol.value).subscribe({
      next: (rs) => {
        this.mdl.cerrar();
        this.estado = rs.data['estado'];
        this.roles = rs.data['rol'];
        this.sel_edo = parseInt(estado.value);
        this.sel_rol = parseInt(rol.value)
        this.resultado = rs.data['institucional'];
        console.log('prueba:   ',rs.data)
        this.filteredResultado = [...this.resultado]; // Actualiza los resultados filtrados al cambiar el año
      },
      error: (error) => {
        this.errorMessage = error.message; // Muestra el mensaje de error al usuario
        //console.error("Error en el componente:", error); // Registro del error en el componente
      }
    });
  }

  editar(id: number, nombre: string, cedula: string){
    this.id_institucional_envio = id.toString();
    this.nombre_institucional_envio = `${cedula} - ${nombre}`
    this.isEditar = true;
  }

  agregar(){
    this.isAgregar = true;
  }

  volver(rsl: any) {
    this.isEditar = rsl.value;
    this.isAgregar = rsl.value;
    if(rsl.validador){
      this.titulo = '!EXITO¡';
      this.tipo_color = 'success';
      this.letra_color = 'light';
      this.mensaje = 'La petición fue realizada con exito.';
      this.mdl.alerta();
      this.mdl.cargando();
      this.servicios.listarInstitucional('1','11').subscribe({
        next: (rs) => {
          this.mdl.cerrar();
          this.estado = rs.data['estado'];
          this.roles = rs.data['rol'];
          this.sel_edo = 1;
          this.sel_rol = 11
          this.resultado = rs.data['institucional'];
          console.log('prueba:   ',rs.data)
          this.filteredResultado = [...this.resultado]; // Actualiza los resultados filtrados al cambiar el año
        },
        error: (error) => {
          this.errorMessage = error.message; // Muestra el mensaje de error al usuario
          //console.error("Error en el componente:", error); // Registro del error en el componente
        }
      });
    }
  }

  quitarAcentos(str: string): string {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

}
